import React from "react";
import { useTable } from "../../Components/useTable";

const HostsLevel = () => {
  const type = "Hosting Level";
  const limitPerpage = 100;
  const pageRowslinit = [100, 200, 500, 1000];
  const headCells = [
    { id: "pictureUrl", numeric: false, label: "Image" },
    { id: "rcoin", numeric: false, label: "RCoins" },
    { id: "level", numeric: false, label: "Level" },
    { id: "created", numeric: false, label: "Created at" },
    { id: "action", numeric: false, label: "Action" },
  ];

  const { tableUI } = useTable({
    headCells,
    type,
    limitPerpage,
    pageRowslinit,
  });
  return (
    <div className="admin-body">
      <div className="table-area">{tableUI}</div>
    </div>
  );
};

export default HostsLevel;
